import mediaQuery from './media-query'

export { mediaQuery }
